import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const EmptyState = ({ icon, title, description, actionLabel, onAction }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, minHeight: 300, textAlign: 'center' }}>
        <Box sx={{ color: 'text.secondary', mb: 2, '& svg': { fontSize: 60, opacity: 0.3 } }}>
            {icon}
        </Box>
        <Typography variant="h6" fontWeight={600} gutterBottom>
            {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400, mb: 3 }}>
            {description}
        </Typography>
        {actionLabel && onAction && (
            <Button variant="contained" onClick={onAction}>
                {actionLabel}
            </Button>
        )}
    </Box>
);

export default EmptyState;
